'use strict';

/**
 * Component for the storage selection
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var ChooseStorageModalLayout = require('modules/collection/modules/location/views/layout/choose-storage-modal');
var RestrictionStoragesModalView = require('modules/base/views/layout/restriction-storages-modal');

var template = require('../../../templates/components/detail/field-storage.hbs');

var StorageComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'buttonChooseStorage': '[data-action="choose-storage"]',
    },

    events: {
        'click @ui.buttonChooseStorage': 'onActionChooseStorage',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },
    },

    onActionChooseStorage: function() {
        if (!App.user.get('licenseStorages')) {
            this.showRestrictionModal();

            return;
        }

        App.addModal(new ChooseStorageModalLayout({
            objectCount: 1,
        }), {
            additionalClassName: 'modal-left modal-medium modal-select-location',
            onAfterClose: function(data) {
                if (data) {
                    App.radio('collection').execute(
                        'change:storage',
                        this.model,
                        data.location
                    );
                }
            }.bind(this),
        });
    },

    showRestrictionModal: function(){
        var restrictionModalView = new RestrictionStoragesModalView({hasClose: true});
        var options = {
            additionalClassName: 'modal-center modal-restriction',
            additionalBgClassName: 'light-bg',
        };
        App.addModal(restrictionModalView, options);
    },

    hasValue: function() {
        return true;
    },
});

module.exports = StorageComponent;